export const getAudiotrackLabel = (audiotrack, index) => {
	let lang = audiotrack.language || audiotrack.lang || '';
	// ignore 'au...' (3q sets aua...auz for unknown languages) and 'und' (for undefined)
	if (lang && (lang.startsWith('au') || lang === 'und')) {
		lang = '';
	}
	return `Audio ${index + 1}${lang ? ` (${lang})` : ''}`;
};
